import React from 'react';
import { Paper } from '@mui/material';
import { SAGE, CREAM } from '../../theme';

const Card = ({ children, sx, ...props }) => (
  <Paper
    elevation={0}
    sx={{
      borderRadius: 4,
      border: `2px solid ${SAGE[200]}`,
      bgcolor: CREAM[50],
      transition: 'box-shadow 0.2s ease',
      '&:hover': {
        boxShadow: '0 4px 20px rgba(107, 140, 94, 0.1)',
      },
      ...sx,
    }}
    {...props}
  >
    {children}
  </Paper>
);

export default Card;
